import useGetExaminationResultById from './useGetExaminationResultById';

export default useGetExaminationResultById;
